// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"656823cc","564":"5cb3c17e","899":"e572e7b1"}[chunkId] + ".chunk.js";
};